var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41483_8262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1997 5.65304C14.1174 5.43821 15.0571 5.33083 15.9997 5.33304C25.333 5.33304 30.6663 15.9997 30.6663 15.9997C29.857 17.5139 28.8917 18.9394 27.7863 20.253M18.8263 18.8264C18.4601 19.2194 18.0185 19.5346 17.5279 19.7532C17.0372 19.9718 16.5075 20.0894 15.9705 20.0989C15.4334 20.1083 14.8999 20.0095 14.4018 19.8084C13.9038 19.6072 13.4513 19.3077 13.0715 18.9279C12.6916 18.5481 12.3922 18.0956 12.191 17.5976C11.9898 17.0995 11.891 16.566 11.9005 16.0289C11.91 15.4918 12.0276 14.9622 12.2462 14.4715C12.4648 13.9808 12.78 13.5392 13.173 13.173M23.9197 23.9197C21.6405 25.657 18.8652 26.6195 15.9997 26.6664C6.66634 26.6664 1.33301 15.9997 1.33301 15.9997C2.99153 12.9089 5.29185 10.2085 8.07967 8.07971L23.9197 23.9197Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 1.33301L30.6663 30.6663",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41483_8262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.569a1995d976a09f47f9dc49806097e6.svg";
export { ForwardRef as ReactComponent };